module.exports = __webpack_public_path__ + "static/media/453.008a463e.webp";